var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "287px",
    height: "210px",
    viewBox: "0 0 287 210",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(120.339506, 81.705351) rotate(-5.000000) translate(-120.339506, -81.705351) translate(5.839506, 9.705351)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    fill: "#E8EAF2",
    x: 0,
    y: 0,
    width: 229,
    height: 144,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CCD7DE",
    x: 0.5,
    y: 0.5,
    width: 186,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    fill: "#CCD7DE",
    x: 4,
    y: 4,
    width: 59,
    height: 33,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,6 L143.5,6 C145.432997,6 147,7.56700338 147,9.5 L147,9.5 C147,11.4329966 145.432997,13 143.5,13 L75.5,13 C73.5670034,13 72,11.4329966 72,9.5 L72,9.5 C72,7.56700338 73.5670034,6 75.5,6 Z",
    id: "Rectangle-4",
    fill: "#CCD7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,15 L113.5,15 C115.432997,15 117,16.5670034 117,18.5 L117,18.5 C117,20.4329966 115.432997,22 113.5,22 L75.5,22 C73.5670034,22 72,20.4329966 72,18.5 L72,18.5 C72,16.5670034 73.5670034,15 75.5,15 Z",
    id: "Rectangle-4",
    fill: "#CCD7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,28 L95.5,28 C97.4329966,28 99,29.5670034 99,31.5 L99,31.5 C99,33.4329966 97.4329966,35 95.5,35 L75.5,35 C73.5670034,35 72,33.4329966 72,31.5 L72,31.5 C72,29.5670034 73.5670034,28 75.5,28 Z",
    id: "Rectangle-4",
    fill: "#CCD7DE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CCD7DE",
    x: 0.5,
    y: 0.5,
    width: 186,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    fill: "#CCD7DE",
    x: 4,
    y: 4,
    width: 59,
    height: 33,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,6 L143.5,6 C145.432997,6 147,7.56700338 147,9.5 L147,9.5 C147,11.4329966 145.432997,13 143.5,13 L75.5,13 C73.5670034,13 72,11.4329966 72,9.5 L72,9.5 C72,7.56700338 73.5670034,6 75.5,6 Z",
    id: "Rectangle-4",
    fill: "#CCD7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,15 L113.5,15 C115.432997,15 117,16.5670034 117,18.5 L117,18.5 C117,20.4329966 115.432997,22 113.5,22 L75.5,22 C73.5670034,22 72,20.4329966 72,18.5 L72,18.5 C72,16.5670034 73.5670034,15 75.5,15 Z",
    id: "Rectangle-4",
    fill: "#CCD7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,28 L95.5,28 C97.4329966,28 99,29.5670034 99,31.5 L99,31.5 C99,33.4329966 97.4329966,35 95.5,35 L75.5,35 C73.5670034,35 72,33.4329966 72,31.5 L72,31.5 C72,29.5670034 73.5670034,28 75.5,28 Z",
    id: "Rectangle-4",
    fill: "#CCD7DE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(58.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 229,
    height: 144,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CCD7DE",
    x: 0.5,
    y: 0.5,
    width: 186,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    fill: "#CCD7DE",
    x: 4,
    y: 4,
    width: 59,
    height: 33,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,6 L143.5,6 C145.432997,6 147,7.56700338 147,9.5 L147,9.5 C147,11.4329966 145.432997,13 143.5,13 L75.5,13 C73.5670034,13 72,11.4329966 72,9.5 L72,9.5 C72,7.56700338 73.5670034,6 75.5,6 Z",
    id: "Rectangle-4",
    fill: "#CCD7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,15 L113.5,15 C115.432997,15 117,16.5670034 117,18.5 L117,18.5 C117,20.4329966 115.432997,22 113.5,22 L75.5,22 C73.5670034,22 72,20.4329966 72,18.5 L72,18.5 C72,16.5670034 73.5670034,15 75.5,15 Z",
    id: "Rectangle-4",
    fill: "#CCD7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,28 L95.5,28 C97.4329966,28 99,29.5670034 99,31.5 L99,31.5 C99,33.4329966 97.4329966,35 95.5,35 L75.5,35 C73.5670034,35 72,33.4329966 72,31.5 L72,31.5 C72,29.5670034 73.5670034,28 75.5,28 Z",
    id: "Rectangle-4",
    fill: "#CCD7DE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CCD7DE",
    x: 0.5,
    y: 0.5,
    width: 186,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    fill: "#CCD7DE",
    x: 4,
    y: 4,
    width: 59,
    height: 33,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,6 L143.5,6 C145.432997,6 147,7.56700338 147,9.5 L147,9.5 C147,11.4329966 145.432997,13 143.5,13 L75.5,13 C73.5670034,13 72,11.4329966 72,9.5 L72,9.5 C72,7.56700338 73.5670034,6 75.5,6 Z",
    id: "Rectangle-4",
    fill: "#CCD7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,15 L113.5,15 C115.432997,15 117,16.5670034 117,18.5 L117,18.5 C117,20.4329966 115.432997,22 113.5,22 L75.5,22 C73.5670034,22 72,20.4329966 72,18.5 L72,18.5 C72,16.5670034 73.5670034,15 75.5,15 Z",
    id: "Rectangle-4",
    fill: "#CCD7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,28 L95.5,28 C97.4329966,28 99,29.5670034 99,31.5 L99,31.5 C99,33.4329966 97.4329966,35 95.5,35 L75.5,35 C73.5670034,35 72,33.4329966 72,31.5 L72,31.5 C72,29.5670034 73.5670034,28 75.5,28 Z",
    id: "Rectangle-4",
    fill: "#CCD7DE"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFiles);
export default __webpack_public_path__ + "static/media/no-files.d2d81f97658cc4a1a4d5ca1974be1d3b.svg";
export { ForwardRef as ReactComponent };